var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgYummy = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.2,
    d: "M23.203 9.204a11.55 11.55 0 0 1-20.006 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.758 15.895a3.3 3.3 0 1 1-6.11 2.496l-.015-.038-.892-2.184-.756-1.852 1.85-.756.757 1.852.892 2.183.005.012.005.011.006.015a1.3 1.3 0 1 0 2.407-.983l-.759-1.85-.096-.235-.055-.136-.756-1.851 1.854-.757.756 1.851.151.37.756 1.852Z",
    clipRule: "evenodd"
  })));
});
SvgYummy.displayName = "SvgYummy";
export default SvgYummy;